import constants from "constants/global";
import ReactGA from "react-ga";
import TableauReportService from "../features/analiticopdf/tableauReportService";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import _ from "lodash";
import moment from "moment";

import {
  getFarmStateFromStorage,
  setSelectedClientInStorage,
  setSelectedFarmInStorage,
  setFarmStateInStorage,
  setHelpCenterPermissionsInStorage,
} from "./storageUtils";
import { LIST_FARMS, SET_FARM } from "redux/actions/actionsConstants";

dayjs.extend(utc);

export const enviaDadosGA = (acao, rotulo, categoria, valor) => {
  ReactGA.event({
    action: acao,
    label: rotulo,
    category: categoria,
    value: valor,
  });
};

export const salvarDadosLocalStorage = (states, action) => {
  if (
    (action.type === SET_FARM || action.type === LIST_FARMS) &&
    states.fazenda.Fazendas.length > 0 &&
    states.fazenda.FazendaSelecionada
  ) {
    states.fazenda.Fazendas = _.filter(states.fazenda.Fazendas, {
      Ativo: true,
      Excluido: false,
    });

    setSelectedFarmInStorage(states.fazenda.FazendaSelecionada);
    setFarmStateInStorage(states.fazenda);
  }

  if (
    (action.type === "SET_CLIENTE" ||
      action.type === "LISTA_USUARIOS_CLIENTES") &&
    states.cliente.ClienteSelecionado
  ) {
    setSelectedClientInStorage(states.cliente.ClienteSelecionado.IdCliente);
    setHelpCenterPermissionsInStorage({
      canAccess: states.cliente.ClienteSelecionado.AcessaCentralAjuda,
      supportAvailable: states.cliente.ClienteSelecionado.LiberadoSuporte,
    });
  }
};

export const checaESalvaLocalstorageProps = ({ getState }) => {
  return (next) => (action) => {
    next(action);
    salvarDadosLocalStorage(getState(), action);
  };
};
export const enviaDadosGAPorRotulo = (acao, rotulo, categoria) => {
  ReactGA.event({
    action: acao,
    label: rotulo,
    category: categoria,
  });
};

export const montarTextoFiltro = (dataInicio, dataFinal) => {
  let emailUsuario = localStorage.getItem("Email");
  let fazendaSelecionada = obterFazendaDoContexto();
  const inicioEmailUsuario = emailUsuario.replace("@", "_");

  const acao = `Fazenda: ${fazendaSelecionada.Nome}
  IdFazenda: ${fazendaSelecionada.IdFazenda}
  DataInicio: ${moment(dataInicio).format("DD/MM/YYYY")}
  DataFinal: ${moment(dataFinal).format("DD/MM/YYYY")}
  `;
  const rotulo = inicioEmailUsuario;
  const categoria = "Conciliacao Filtro";

  enviaDadosGAPorRotulo(acao, rotulo, categoria);
};

export const obterFazendaDoContexto = () => {
  const localFazendas = getFarmStateFromStorage();
  return localFazendas != null ? localFazendas.currentFarm : null;
};

export const buscaTicketTableauEmbedded = async (email) => {
  try {
    const ticket = await TableauReportService.buscaTicketTableauEmbedded(email);
    return ticket.data;
  } catch (exception) {
    console.log(`Erro ao buscar ticket tableau embedded: ${exception}`);
    return "";
  }
};

export const formatDateHour = (date) =>
  dayjs(date).format(constants.defaultDateTimeFormat);

export const removeUndefinedEntries = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value || value === 0 || value === false) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const getComparator = (order, orderBy) => {
  return order === constants.orderBy.desc
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

export const calcPeriodMonthTitles = (initialDate, dateMonthFormat) => {
  const titles = Array.from({ length: 12 }, (_, position) => {
    const cloneDate = dayjs(initialDate);
    return cloneDate.add(position, "M").format(dateMonthFormat);
  });
  return titles;
};

export const convertStringBooleanToBoolean = (value) => {
  switch (value) {
    case "true":
      return true;
    case "false":
      return false;
    default:
      return value;
  }
};

// Função para mover um ponto para o sul e, opcionalmente, para leste/oeste
export const moverPosicao = (
  latitude,
  longitude,
  distanciaSul,
  distanciaLeste = 0
) => {
  // Distância em graus aproximadamente
  const distanciaEmGrausLat = distanciaSul / 111320; // 1 grau de latitude ≈ 111.320 metros
  const distanciaEmGrausLng =
    distanciaLeste / (111320 * Math.cos(latitude * (Math.PI / 180))); // Ajustar para a longitude considerando a latitude

  // Nova latitude diminuída pela distância desejada
  const novaLatitude = latitude - distanciaEmGrausLat;
  // Nova longitude ajustada pela distância desejada (se fornecida)
  const novaLongitude = longitude + distanciaEmGrausLng;

  return { lat: novaLatitude, lng: novaLongitude };
};
/**
 * Verifica se um valor é uma data válida.
 *
 * @param {*} value - O valor a ser verificado.
 * @returns {boolean} - True se o valor for uma data válida, false caso contrário.
 */
export const isValidDate = (value) =>
  value instanceof Date && !isNaN(value.getTime());

/**
 * Converte uma string no formato ISO 8601 em um objeto Date.
 *
 * @param {string} dateString - A string a ser convertida.
 * @returns {Date} - O objeto Data.
 * @throws {Error} - Se a string não estiver em um formato válido.
 */

export const parseISODate = (dateString) => {
  const date = new Date(dateString);
  if (isValidDate(date)) {
    return date;
  } else {
    throw new Error("Invalid ISO date string");
  }
};

/**
 * Calcula a diferença entre duas datas e retorna os campos selecionados.
 *
 * @param {Date|string} startDate - A data de início. Pode ser um objeto Date ou uma string no formato ISO 8601.
 * @param {Date|string} endDate – A data de término. Pode ser um objeto Date ou uma string no formato ISO 8601.
 * @returns {Object} – Um objeto contendo os campos selecionados e seus valores.
 * @throws {Error} - Se startDate ou endDate não forem objetos de data válidos ou strings no formato ISO 8601.
 */

export const dateDiff = (startDate, endDate) => {
  // Converte strings em objetos Date, se necessário
  if (typeof startDate === "string") {
    startDate = parseISODate(startDate);
  }
  if (typeof endDate === "string") {
    endDate = parseISODate(endDate);
  }

  // Valida startDate e endDate
  if (!isValidDate(startDate) || !isValidDate(endDate)) {
    throw new Error("Invalid start or end date");
  }

  const millisecondsDiff = Math.abs(endDate - startDate);
  const result = {};

  // Calcular todas as unidades de uma vez
  const totalSeconds = millisecondsDiff / 1000;
  result.hours = Math.floor(totalSeconds / 3600);
  result.minutes = Math.floor((totalSeconds % 3600) / 60);
  result.seconds = Math.floor(totalSeconds % 60);
  result.milliseconds = millisecondsDiff % 1000;

  return result;
};

/**
 * Verifica se uma data está fora do intervalo de datas especificado.
 *
 * @param {string | Date} [minDate] - A data mínima permitida (opcional).
 * @param {string | Date} maxDate - A data máxima permitida (obrigatória).
 * @param {string | Date} dateToCheck - A data a ser verificada (obrigatória).
 * @returns {string} Uma mensagem de erro se a data estiver fora do intervalo, ou uma string vazia se a data for válida.
 */
export const dateOutOfRange = (minDate, maxDate, dateToCheck) => {
  const _minDate = minDate ? new Date(minDate).getTime() : null;
  const _maxDate = new Date(maxDate).getTime();
  const _dateToCheck = new Date(dateToCheck).getTime();

  if (_minDate !== null && _dateToCheck < _minDate) {
    return "A data não pode ser anterior à data mínima";
  } else if (_dateToCheck > _maxDate) {
    return "A data não pode ser superior à data máxima";
  }

  return "";
};

export const ajustaDataComTimezoneFazenda = (data, timezoneFazenda) => {
  return dayjs(data, { utc: true }).subtract(timezoneFazenda, "hour");
};

export const isEven = (value) => {
  return value % 2 === 0;
};
